export default "__VITE_ASSET__DBrA7REX__"